import { useState, useEffect } from "react";
import axios from "axios";
import EventCard from "./EventCard";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FeaturedEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useLang();

  useEffect(() => {
    axios.get(`${API}/events/featured`).then(res => setEvents(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => <div key={`skel-${i}`} className="bg-[#141414] border border-[#262626] h-96 animate-pulse" />)}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="events" data-testid="featured-events-section" className="pb-24 md:pb-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-16">
          <span className="text-xs tracking-[0.3em] uppercase text-[#C5A059] font-['Outfit'] font-semibold block mb-4">{t("events_tag")}</span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-light tracking-tight text-white">{t("events_title")}</h2>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {events.map((event, index) => <EventCard key={event.slug || event.id} event={event} index={index} />)}
        </div>
      </div>
    </section>
  );
}
